import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {homeMock, recordMock, subRankMock} from './mock'

export async function uploadImg(params) {
  const resp = await http.post(
    '/live/misc/upload_img',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export async function get_jobsystem_info(params) {
  const resp = await http.post(
    '/live/commonactivity/get_jobsystem_info',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export async function get_stage_task_info(params) {
  const resp = await http.post(
    '/live/commonactivity/get_stage_task_info',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export async function get_stage_task_history(params) {
  const resp = await http.post(
    '/live/commonactivity/get_stage_task_history',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export async function get_anniversary_2025_ticket_record(params) {
  // return new Promise((r) => {
  //   setTimeout(() => {
  //     r(recordMock as any)
  //   }, 1000)
  // })

  const resp = await http.post(
    '/live/activity/get_anniversary_2025_ticket_record',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export const homepage = createAsyncThunk(
  'YearInfluence2025/get_anniversary_2025_ticket_homepage',
  async (params: any, store: any) => {
    // return new Promise((r) => {
    //   setTimeout(() => {
    //     r(homeMock as any)
    //   }, 1000)
    // })

    const resp = await http.post(
      '/live/activity/get_anniversary_2025_ticket_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_anniversary_2025_ticket_vote = createAsyncThunk(
  'YearInfluence2025/get_anniversary_2025_ticket_vote',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/activity/get_anniversary_2025_ticket_vote',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_anniversary_2025_ticket_rank = createAsyncThunk(
  'YearInfluence2025/get_anniversary_2025_ticket_rank',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/activity/get_anniversary_2025_ticket_rank',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_anniversary_2025_ticket_sub_rank = createAsyncThunk(
  'YearInfluence2025/get_anniversary_2025_ticket_sub_rank',
  async (params: any, store: any) => {
    // return new Promise((r) => {
    //   setTimeout(() => {
    //     r(subRankMock as any)
    //   }, 1000)
    // })

    const resp = await http.post(
      '/live/activity/get_anniversary_2025_ticket_sub_rank',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_anniversary_2025_ticket_search = createAsyncThunk(
  'YearInfluence2025/get_anniversary_2025_ticket_search',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/activity/get_anniversary_2025_ticket_search',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_privilege_box_homepage = createAsyncThunk(
  'YearInfluence2025/get_privilege_box_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_privilege_box_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const send_privilege_box = createAsyncThunk(
  'YearInfluence2025/send_privilege_box',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/send_privilege_box',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_job_done_reward = createAsyncThunk(
  'YearInfluence2025/get_job_done_reward',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_job_done_reward',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  home: any
  subRankInfo: any
}

const initialState: InitialStateType = {
  home: {},
  subRankInfo: {},
}

export const YearInfluence2025Slice = createSlice({
  name: 'YearVote2025Slice',
  initialState,
  reducers: {
    setSubRankInfo: (state, action) => {
      Object.assign(state, {
        subRankInfo: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        home: {
          ...state.home,
          ...action.payload,
        },
      })
    })
  },
})
export default YearInfluence2025Slice.reducer
export const YearInfluence2025Actions = YearInfluence2025Slice.actions

export const useYearInfluence2025State = () => {
  const data = useSelector((state) => {
    return state.YearInfluence2025
  })
  return data
}
